import {
  createTranslationRef,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';

// Translation ref para títulos de navegação do sidebar
export const sidebarTitlesRef = createTranslationRef({
  id: 'app.sidebar',
  messages: {
    catalog:          'Catalog',
    'api-docs':       'APIs',
    'catalog-graph':  'Catalog Graph',
    techdocs:         'Docs',
    kubernetes:       'Kubernetes',
    notifications:    'Notifications',
    scaffolder:       'Create',
    'catalog-import': 'Register Existing Component',
    'app-visualizer': 'Visualizer',
    rbac:             'RBAC',
    qeta:             'Q&A Forum',
    announcements:    'Announcements',
    search:           'Search',
    settings:         'Settings',
  },
});

// Tradução pt-BR
export const sidebarTitlesPtBR = createTranslationMessages({
  ref: sidebarTitlesRef,
  full: true,
  messages: {
    catalog:          'Catálogo',
    'api-docs':       'APIs',
    'catalog-graph':  'Grafo do Catálogo',
    techdocs:         'Documentação',
    kubernetes:       'Kubernetes',
    notifications:    'Notificações',
    scaffolder:       'Criar',
    'catalog-import': 'Registrar Componente',
    'app-visualizer': 'Visualizador',
    rbac:             'RBAC',
    qeta:             'Fórum',
    announcements:    'Anúncios',
    search:           'Buscar',
    settings:         'Configurações',
  },
});
